import { FormControl } from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { CheckboxIcon } from '../../components/CheckboxIcon'
import { CheckboxIconGroup } from '../../components/CheckboxIconGroup'
import { CheckboxStack } from '../../components/CheckboxStack'
import { FormLabel } from '../../components/FormLabel'

export const InsuranceType = () => {
  const { control } = useFormContext()

  return (
    <FormControl>
      <FormLabel>Typ pojištění</FormLabel>

      <CheckboxIconGroup control={control} name="insuranceType">
        <CheckboxStack>
          <CheckboxIcon value="buildings" customIcon="buildings">
            Budovy
          </CheckboxIcon>
          <CheckboxIcon value="stock" customIcon="stock">
            Zásoby
          </CheckboxIcon>
          <CheckboxIcon customIcon="vehicle" value="vehicle">
            Stroje, elektronika a&nbsp;movité věci
          </CheckboxIcon>
          <CheckboxIcon customIcon="responsibility" value="responsibility">
            Odpovědnost
          </CheckboxIcon>
          <CheckboxIcon customIcon="interruptions" value="interruptions">
            Přerušení provozu
          </CheckboxIcon>
        </CheckboxStack>
      </CheckboxIconGroup>
    </FormControl>
  )
}
